import React, { useState, useEffect } from 'react';
import './CheckoutModal.css';

function validateLibyaPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.length >= 8;
}

/**
 * تأكيد الطلب: هاتف + عنوان (كلاهما إجباري)
 */
export default function CheckoutModal({ isOpen, onClose, onConfirm, loading, title = 'إتمام الطلب' }) {
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!validateLibyaPhone(phone)) {
      setError('أدخل رقم هاتف صالح (8 أرقام على الأقل)');
      return;
    }
    if (!String(address || '').trim()) {
      setError('العنوان مطلوب');
      return;
    }
    // افتح نافذة واتساب فورياً (ضمن نفس حدث المستخدم) لتفادي حظر المتصفح
    const popup = window.open('about:blank', '_blank');
    if (!popup) {
      setError('المتصفح حظر فتح واتساب. فعّل Pop-ups ثم أعد المحاولة.');
      return;
    }
    onConfirm({ phone: phone.trim(), address: address.trim() }, popup);
  };

  return (
    <div className="checkout-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="checkout-modal"
        role="dialog"
        aria-labelledby="checkout-modal-title"
        onClick={(ev) => ev.stopPropagation()}
      >
        <div className="checkout-modal-header">
          <h2 id="checkout-modal-title" className="checkout-modal-title">
            {title}
          </h2>
          <button type="button" className="checkout-modal-close" onClick={onClose} aria-label="إغلاق">
            <i className="fas fa-times" />
          </button>
        </div>
        <form className="checkout-modal-form" onSubmit={handleSubmit}>
          <label className="checkout-modal-label">
            رقم الهاتف <span className="checkout-required">*</span>
            <input
              type="tel"
              className="checkout-modal-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="مثال: 0912345678"
              autoComplete="tel"
              required
              dir="ltr"
            />
          </label>
          <label className="checkout-modal-label">
            العنوان <span className="checkout-required">*</span>
            <textarea
              className="checkout-modal-textarea"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="المدينة، الحي…"
              rows={3}
              required
            />
          </label>
          {error && <div className="checkout-modal-error">{error}</div>}
          <div className="checkout-modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              إلغاء
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'جاري الإرسال…' : 'متابعة إلى واتساب'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export { validateLibyaPhone };
